export class Ticket {
    id!: number;
    subject: string;
    description: string;
    status: string;
    type: string;
    categoryId: number | null;
    categoryName: string;
    subCategoryId: number | null;
    subCategoryName: string;
    powerStationId: number | null;
    powerStationName: string;
    skidId: number | null;
    skidName: string;
    equipmentId: number | null;
    equipmentName: string;
    scheduling: Date | null;
    createdByName: string;
    createdAt: Date | null;
    finishedByName: string;
    finishedAt: Date | null;
    alarmIds: number[];

    constructor() {
        this.description = "";
        this.subject = "";
        this.description = "";
        this.status = "";
        this.type = "";
        this.categoryId = null;
        this.categoryName = "";
        this.subCategoryId = null;
        this.subCategoryName = "";
        this.powerStationId = null;
        this.powerStationName = "";
        this.skidId = null;
        this.skidName = "";
        this.equipmentId = null;
        this.equipmentName = "";
        this.scheduling = null;
        this.createdByName = "";
        this.createdAt = null;
        this.finishedByName = "";
        this.finishedAt = null;
        this.alarmIds = new Array();
    }
}

export class TicketMessage {
    id!: number;
    ticketId: number | null;
    description: string;
    userId: number | null;
    userName: string;
    date: Date | null;

    constructor() {
        this.ticketId = null;
        this.description = "";
        this.userId = null;
        this.userName = "";
        this.date = null;
    }
}

export class TicketSendMessage {
    ticketId!: number;
    message: string;

    constructor() {
        this.message = "";
    }
}

export class TicketAttachment {
    id!: number;
    ticketId: number | null;
    fileName: string;
    fileType: string;
    userId: number | null;
    userName: string;
    date: Date | null;

    constructor() {
        this.ticketId = null;
        this.fileName = "";
        this.fileType = "";
        this.userId = null;
        this.userName = "";
        this.date = null;
    }
}

export class TicketSendAttachment {
    ticketId: number | null;
    fileName: string;
    fileData: string;
    fileType: string;

    constructor() {
        this.ticketId = null;
        this.fileName = "";
        this.fileData = "";
        this.fileType = "";
    }
}
